// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.transfer-invite-dialog__toggle {
    background: none;
    border: none;
    box-shadow: none;
    padding: 0;
    margin: 0;
    text-transform: none;
    color: #039be5;
    font-size: 1.8rem;
    height: auto !important;
    line-height: 1.8rem !important;
    display: flex;
    letter-spacing: normal;
}

.transfer-invite-dialog__toggle:hover {
    background: none; 
    border: none; 
    box-shadow: none;
}

.transfer-invite-dialog__toggle:focus {
    background: none; 
}

.transfer-invite-dialog__menu {
    border: 1px solid;
    width: 48rem;
    height: 45rem;
    text-align: center;
    background-color: rgb(255, 255, 255);
    box-shadow: 0px 2px 7px 1px rgba(0,0,0,0.75);
    border-radius: 5px;
    z-index: 10;
}

.transfer-invite-dialog__search {
    margin: 0 0.4rem;
    margin-top: 0.2rem;
}

.transfer-invite-dialog__action-btn {
    width: 7.2rem;
    height: 2.7rem;
    padding: 0;
    font-size: 0.9rem;
    box-shadow: none;
    border-radius: 0;
    margin: auto auto 0.5rem auto;
    line-height: 0;
}

.transfer-invite-dialog__body {
    padding-left: 1rem;
    text-align: left;
    max-height: 29.5rem;
    overflow-y: auto;
}

.invite-dialog__body {
    padding-left: 1rem;
    text-align: left;
    max-height: 32.5rem;
    overflow-y: auto;
}

.transfer-invite-dialog__footer {
    width: 100%;
    position: absolute;
    bottom: .5rem;
}

.transfer-invite-dialog__actions-selection-container {
    display: flex;
    flex-direction: row;
    margin: 0.9rem auto;
}

.transfer-invite-dialog__action-type {
    margin: auto;
}

`, "",{"version":3,"sources":["webpack://./src/app/chat/transfer-invite-dialog/TransferInviteDialog.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,oBAAoB;IACpB,cAAc;IACd,iBAAiB;IACjB,uBAAuB;IACvB,8BAA8B;IAC9B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,oCAAoC;IACpC,4CAA4C;IAC5C,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".transfer-invite-dialog__toggle {\r\n    background: none;\r\n    border: none;\r\n    box-shadow: none;\r\n    padding: 0;\r\n    margin: 0;\r\n    text-transform: none;\r\n    color: #039be5;\r\n    font-size: 1.8rem;\r\n    height: auto !important;\r\n    line-height: 1.8rem !important;\r\n    display: flex;\r\n    letter-spacing: normal;\r\n}\r\n\r\n.transfer-invite-dialog__toggle:hover {\r\n    background: none; \r\n    border: none; \r\n    box-shadow: none;\r\n}\r\n\r\n.transfer-invite-dialog__toggle:focus {\r\n    background: none; \r\n}\r\n\r\n.transfer-invite-dialog__menu {\r\n    border: 1px solid;\r\n    width: 48rem;\r\n    height: 45rem;\r\n    text-align: center;\r\n    background-color: rgb(255, 255, 255);\r\n    box-shadow: 0px 2px 7px 1px rgba(0,0,0,0.75);\r\n    border-radius: 5px;\r\n    z-index: 10;\r\n}\r\n\r\n.transfer-invite-dialog__search {\r\n    margin: 0 0.4rem;\r\n    margin-top: 0.2rem;\r\n}\r\n\r\n.transfer-invite-dialog__action-btn {\r\n    width: 7.2rem;\r\n    height: 2.7rem;\r\n    padding: 0;\r\n    font-size: 0.9rem;\r\n    box-shadow: none;\r\n    border-radius: 0;\r\n    margin: auto auto 0.5rem auto;\r\n    line-height: 0;\r\n}\r\n\r\n.transfer-invite-dialog__body {\r\n    padding-left: 1rem;\r\n    text-align: left;\r\n    max-height: 29.5rem;\r\n    overflow-y: auto;\r\n}\r\n\r\n.invite-dialog__body {\r\n    padding-left: 1rem;\r\n    text-align: left;\r\n    max-height: 32.5rem;\r\n    overflow-y: auto;\r\n}\r\n\r\n.transfer-invite-dialog__footer {\r\n    width: 100%;\r\n    position: absolute;\r\n    bottom: .5rem;\r\n}\r\n\r\n.transfer-invite-dialog__actions-selection-container {\r\n    display: flex;\r\n    flex-direction: row;\r\n    margin: 0.9rem auto;\r\n}\r\n\r\n.transfer-invite-dialog__action-type {\r\n    margin: auto;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
